import { entityNameSorter } from '@lib/generic.utils'
import { agEndDateCol, agStartDateCol } from '@/ag-grid/ag-columns'
// Components
import ActionsColumn from './ActionsColumn'

export const options = {
  computed: {
    options() {
      return {
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            sort: 'asc',
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/licenses/${params.data.license_id}`,
                newTab: true
              }
            }
          },

          {
            headerName: 'Publisher',
            field: 'publisher',
            comparator: entityNameSorter,
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/publishers/${params.data.publisher.id}`,
                newTab: true,
                value: params.data.publisher.name
              }
            }
          },

          agStartDateCol(),
          agEndDateCol(),

          {
            headerName: 'Actions',
            sortable: false,
            resizable: false,
            lockVisible: true,
            cellRendererFramework: ActionsColumn
          }
        ]
      }
    }
  }
}
